module.exports = __webpack_public_path__ + "static/media/14UNEP23.bffc5a51.jpg";